import { usersComponent, usersCtrl } from './components/users.component'
import { usersTableComponent, usersTableCtrl } from './components/usersTable.component'
import { newUserComponent, newUserCtrl } from './components/newUser.component'
import { setPinComponent, setPinCtrl } from './components/setPin.component'
import { loginComponent, loginCtrl } from './components/login.component'
import { privacyStatementEnComponent, privacyStatementEsComponent, privacyStatementFrComponent } from './components/privacyStatements.component'

const authComponent  = {
    template: require('./auth.html'),
    controller: 'authCtrl',
    controllerAs: 'vm'
}

class authCtrl {
  /*@ngInject*/
  constructor($state) {
    this.$state = $state
  }
  $onInit() {
    this.screen = 'users'
  }
  login() {
    this.setScreen('login')
  }
  newUser() {
    this.setScreen('newuser')
  }
  setPin() {
    this.setScreen('setpin')
  }
  setScreen(screen) {
    this.screen = screen
  }
  back() {
    this.$state.reload()
  }
}

export const appAuthModule = angular.module('app.auth', [])
  .component('auth', authComponent)
  .controller('authCtrl', authCtrl)
  .component('login', loginComponent)
  .controller('loginCtrl', loginCtrl)
  .component('users', usersComponent)
  .controller('usersCtrl', usersCtrl)
  .component('usersTable', usersTableComponent)
  .controller('usersTableCtrl', usersTableCtrl)
  .component('newUser', newUserComponent)
  .controller('newUserCtrl', newUserCtrl)
  .component('setPin', setPinComponent)
  .controller('setPinCtrl', setPinCtrl)
  .component('privacyStatementEn', privacyStatementEnComponent)
  .component('privacyStatementEs', privacyStatementEsComponent)
  .component('privacyStatementFr', privacyStatementFrComponent)



// WEBPACK FOOTER //
// ./src/app/auth/auth.js